/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [leave-space-dialog.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 05.04.20, 18:41
 */
import React, {Fragment, useEffect} from 'react';
import DialogBox from "../dialog-box";
import {useAuthorization} from "../../../selectors";
import {useLanguage} from "../../configuration/configuration";
import useFetchQRCode from "../../hooks/use-fetch-qrcode";
import {SUCCESS_STATUS} from "../../../actions";
import {Spinner} from "../../util/spinner";
import {cn} from "../../util/text-utils";
import {fs_large, QRCodeIcon} from "../../navigation/icons/nav-icons";

export const QRCode = ({qrCode, className = null}) => {
    return <div className={cn([className, className])} dangerouslySetInnerHTML={{__html: qrCode}}/>
}

const ShowQRCodeDialog = ({space, isOpen, setIsOpen}) => {
    const {isAuthorized, principalUsername} = useAuthorization();
    const {fetchMemberQrCode, qrCode, status} = useFetchQRCode();
    const Lang = useLanguage();

    useEffect(() => {
        isAuthorized && fetchMemberQrCode(principalUsername, space.id)
    }, [space.id]);

    if (isAuthorized && status !== SUCCESS_STATUS) return <Spinner/>

    return <DialogBox title={Lang.qrcode.member.title}
                      action={null}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      isDisabled={!isAuthorized}
                      callback={null}>

        {isAuthorized && <Fragment>
            <div className='my-1 text-center'>
                <div>{Lang.qrcode.member.text}</div>
                <div className='fw-bold'>{qrCode.spaceName}</div>
                {qrCode.date && <div>{Lang.qrcode.member.date} {qrCode.date}</div>}
            </div>

            <QRCode qrCode={qrCode.svgQrCode}/>

            <div className='my-1 text-center'>
                <div>{qrCode.fullname}</div>
                <div>{qrCode.membership} {Lang.qrcode.member.membership}</div>
            </div>
        </Fragment>}

        {!isAuthorized && <Fragment>
            <div className='mt-4'>
                {Lang.qrcode.member.notAuthorized}
            </div>

            <div className='mt-4 text-center'>
                <QRCodeIcon size={fs_large} color='error'/>
            </div>
        </Fragment>}

    </DialogBox>
}

export default ShowQRCodeDialog;